import { useScreenSize } from '@/hooks/useScreenSize';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

const FooterBackIcon = (props: Props) => {
    const { color = 'white', width = 8, height = 12, ...rest } = props;

    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;

    return (
        <svg
            width={scaleWidthPixel(numericWidth)}
            height={scaleHeightPixel(numericHeight)}
            viewBox="0 0 8 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path d="M7.19209 11.2992L0.785156 5.81417L7.19209 0.703125" stroke={color} strokeLinecap="square" />
        </svg>
    );
};

export default FooterBackIcon;
